<script setup lang="ts">
import {
  PhBriefcase as Briefcase,
  PhUserFocus as UserFocus,
  PhUsersThree as UsersThree,
} from "@phosphor-icons/vue";
import type { ResultDefinition } from "../types";

defineProps<{
  highlights: ResultDefinition["highlights"];
  variant?: "result" | "poster";
}>();

const items = [
  { key: "core", label: "核心性格", icon: UserFocus },
  { key: "work", label: "工作方式", icon: Briefcase },
  { key: "boundary", label: "边界与人际", icon: UsersThree },
] as const;
</script>

<template>
  <section class="identity-highlights" :class="`identity-highlights--${variant ?? 'result'}`" aria-label="角色核心特征">
    <header class="identity-highlights__heading">
      <i></i><strong>你的 3 项牛马画像</strong><i></i>
    </header>
    <div class="identity-highlights__grid">
      <article
        v-for="(item, index) in items"
        :key="item.key"
        class="identity-highlight"
        :class="{ 'identity-highlight--featured': index === 0 }"
      >
        <div class="identity-highlight__header">
          <span class="identity-highlight__icon"><component :is="item.icon" weight="fill" /></span>
          <strong class="identity-highlight__label">{{ item.label }}</strong>
        </div>
        <p>{{ highlights[item.key] }}</p>
      </article>
    </div>
  </section>
</template>
